import {
  PrepaidBookingRefundResponse,
  StatusPrepaidBookingRefundResponse,
} from '@msc-b2c/interfaces/interfaces';
import { RefundStatusEnum } from '@msc-b2c/interfaces/enums';

export type RefundPassengersSelectionMap = Record<string, Record<string, boolean>>;

export const getSelectedRefundPassengerIds = (
  refundPassengersToProcess: RefundPassengersSelectionMap
): string[] =>
  Object.values(refundPassengersToProcess).flatMap((cabinPassengers) =>
    Object.entries(cabinPassengers)
      .filter(([, isSelected]) => isSelected)
      .map(([passengerId]) => passengerId)
  );

export const getSelectedRefundCabinIds = (
  refundPassengersToProcess: RefundPassengersSelectionMap
): string[] =>
  Object.entries(refundPassengersToProcess)
    .filter(([, cabinPassengers]) => Object.values(cabinPassengers).some(Boolean))
    .map(([cabinId]) => cabinId);

export const getRefundResponseStatuses = (
  response: PrepaidBookingRefundResponse
): StatusPrepaidBookingRefundResponse[] => [
  ...(response?.onboardServices ?? []).map((entry) => entry.status),
  ...(response?.excursions ?? []).map((entry) => entry.status),
];

export const isRefundResponseSuccessful = (response: PrepaidBookingRefundResponse): boolean => {
  const statuses = getRefundResponseStatuses(response);
  return statuses.length > 0 && !statuses.includes(RefundStatusEnum.FAILURE);
};
